import IsIos from '@/mixins/is-ios.js'
import CurrentUserResolver from '@/mixins/current-user-resolver.js'
import PushNotificationFlow from '@/mixins/push-notification-flow.js'
import formValidator from '@/mixins/form-validator.js'
import serviceProviderStore from '@/stores/service-provider-store.js'
import sessionStore from '@/stores/session-store.js'
import toastStore from '@/stores/toast-store.js'
import axios from 'axios'
import { required } from 'vuelidate/lib/validators'
import logo from '@/assets/images/collectomate-logo.png'
import { EventBus } from '../../../event-bus.js'
import RedirectToLockersOrDeliveries from '@/mixins/redirect-to-lockers-or-deliveries.js'

const PATH_TO_PROTECTED_ROUTE = '/okta-setup'

export default {
  name: 'LoginCmp',
  mixins: [
    IsIos,
    CurrentUserResolver,
    formValidator,
    PushNotificationFlow,
    RedirectToLockersOrDeliveries,
  ],
  data() {
    return {
      errors: {},
      submitted: false,
      logo: logo,
      user: {
        email: null,
        password: null,
      },
      blocker: false,
      validatedItemKey: 'user',
      passwordInputType: 'password',
    }
  },
  computed: {
    isAuthStandard() {
      return serviceProviderStore.getters.authMethods.includes('standard')
    },
    oktaAuth() {
      return (
        serviceProviderStore.getters.authMethods.includes('okta') &&
        serviceProviderStore.getters.oktaClientId &&
        serviceProviderStore.getters.oktaIssuer
      )
    },
    openAmAuth() {
      return serviceProviderStore.getters.authMethods.includes('open_am')
    },
    isAuthAad() {
      return serviceProviderStore.getters.authMethods.includes('aad')
    },
  },
  watch: {
    currentUser: {
      handler: function () {
        if (this.currentUser) this.redirectToLockersOrDeliveries()
      },
      deep: true,
    },
    user: {
      handler: function () {
        this.validateForm()
      },
      deep: true,
    },
  },
  mounted() {
    this.showLoginMessages()

    if (this.$isZabka) {
      if (!this.wasMsalLogoutWasPerformedLastTime()) {
        this.automaticMsalLogin()
      } else {
        this.removeMsalLogoutIndicator()
      }
    }
  },
  methods: {
    signIn: function (e) {
      e.preventDefault()
      this.submitted = true
      this.validateForm()

      if (Object.keys(this.errors).length > 0) {
        toastStore.commit('error', {
          message: this.$t('messages.validationErrorFillFields'),
        })
      } else {
        this.blocker = true

        axios({
          method: 'post',
          url: 'auth/sign_in',
          data: {
            email: this.user.email,
            password: this.user.password,
          },
        })
          .then(response => {
            this.blocker = false
            if (response.status == 200) {
              sessionStore.commit('setData', response.data.token)
              sessionStore.commit('setUser', response.data.user)

              // REPEATED CODE...
              if (response.data.user.isAdmin || response.data.user.hasAnyAdminMembers) {
                this.$store.commit(
                  'setShowMyLockersOnly',
                  response.data.user.isAdmin || response.data.user.hasAnyAdminMembers,
                )
              }
              setTimeout(this.redirectToLockersOrDeliveries)
            }
            // IT'S GETTING CROWDED HERE
            EventBus.$emit(`showOnboardingAndModalsWhenLogin`)
            EventBus.$emit(`showAddToHomeScreenPrompt`)
            EventBus.$emit(`prefetchLockers`)
            this.setSkipLocationCheckTrue()
          })
          .catch(error => {
            this.blocker = false
            if (error.response.status == 422) {
              this.errors = { ...error.response.data.errors }
            }
            const errorMessage = error.response.data.errors
              ? Object.values(error.response.data.errors).join(', ')
              : this.$t('messages.error')
            toastStore.commit('error', { message: errorMessage })
          })
      }
    },
    showPasswordHandler() {
      this.passwordInputType = 'text'
    },
    hidePasswordHandler() {
      this.passwordInputType = 'password'
    },
    setSkipLocationCheckTrue() {
      window.localStorage.setItem('skipLocalizationCheck', true)
    },
    oktaSignIn() {
      // INFO: This only consumes `this.$auth` created in `routes.js` in line `const oktaAuth = new OktaAuth(oktaConfig)`
      this.$auth.signInWithRedirect({ originalUri: PATH_TO_PROTECTED_ROUTE })
    },
    openAmSignIn() {
      const url = 'https://login.pwc.com/openam/oauth2/authorize'
      const state = this.$random()
      const clientId = 'urn:pwc.pwa.collectomate.io'
      const scope = 'openid profile email cloudEmail'
      const redirectUri = 'https://pwc.pwa.collectomate.io/sso-sign-in'
      const responseType = 'code'

      window.location.href = `${url}?state=${state}&client_id=${clientId}&scope=${scope}&redirect_uri=${redirectUri}&response_type=${responseType}`
    },
    wasMsalLogoutWasPerformedLastTime() {
      console.log('################### wasMsalLogoutWasPerformedLastTime')
      return localStorage.getItem('add_logout')
    },
    automaticMsalLogin() {
      console.log('################### automaticMsalLogin')

      // REGISTER handleRedirectPromise handler is necessary
      const _this = this
      this.$msal
        .handleRedirectPromise()
        .then(response => {
          const account = _this.getMsalAccount(response)
          if (account) {
            _this.getMsalToken(account)
          } else {
            this.aadSignIn()
          }
        })
        .catch(error => {
          console.log('################### automaticMsalLogin error', error)
        })
    },
    aadSignIn() {
      if (this.$msal) {
        this.$msal.loginRedirect({
          scopes: ['User.Read'],
        })
      }
    },
    removeMsalLogoutIndicator() {
      console.log('################### removeMsalLogoutIndicator')
      localStorage.removeItem('add_logout')
    },
    getMsalAccount(response) {
      console.log('################### getMsalAccount', response)
      const account = this.$msal.getAllAccounts()?.[0]
      return account || null
    },
    getMsalToken(account) {
      const _this = this
      const accessTokenRequest = {
        scopes: ['User.Read'],
        account: account,
      }
      this.$msal
        .acquireTokenSilent(accessTokenRequest)
        .then(accessTokenResponse => {
          _this.callAadGraphQlApi(accessTokenResponse.accessToken)
        })
        .catch(() => {
          _this.$error({ message: 'Cannot fetch Msal access token' })
        })
    },
    callAadGraphQlApi(token) {
      axios({
        method: 'GET',
        url: 'https://graph.microsoft.com/v1.0/me',
        headers: {
          Authorization: `Bearer ${token}`,
        },
      }).then(response => {
        this.collectomateAadSignIn(response)
      })
    },
    collectomateAadSignIn(response) {
      axios({
        method: 'post',
        url: 'auth/aad_sign_in',
        headers: { Authorization: '' },
        data: {
          email: response?.data?.userPrincipalName,
          service_provider_id: serviceProviderStore.getters.id,
        },
      })
        .then(response => {
          if (response.status == 200) {
            sessionStore.commit('setData', response.data.token)
            sessionStore.commit('setUser', response.data.user)
            setTimeout(this.redirectToLockersOrDeliveries)
          }
          // IT'S GETTING CROWDED HERE
          EventBus.$emit(`showOnboardingAndModalsWhenLogin`)
          EventBus.$emit(`showAddToHomeScreenPrompt`)
          EventBus.$emit(`prefetchLockers`)
          this.setSkipLocationCheckTrue()
        })
        .catch(error => {
          this.blocker = false
          if (error.response.status == 422) {
            this.errors = { ...error.response.data.errors }
          }
          const errorMessage = error.response.data.errors
            ? Object.values(error.response.data.errors).join(', ')
            : this.$t('messages.error')
          toastStore.commit('error', { message: errorMessage })
        })
        .finally(() => {
          this.blocker = false
        })
    },
    showLoginMessages() {
      setTimeout(() => {
        if ((this.$route.query || {}).confirmed) {
          alert('Konto zostało poprawnie aktywowane. Możesz się zalogować.')
          this.$route.query = {}
        } else if ((this.$route.query || {}).not_confirmed) {
          alert('Nie udało się aktywować konta! Prawdopodobnie wiadomość aktywacyjna wygasła.')
          this.$route.query = {}
        }
      }, 1000)
    },
  },
  validations() {
    if (this.submitted) {
      return {
        user: {
          email: {
            required,
          },
          password: {
            required,
          },
        },
      }
    } else {
      return {}
    }
  },
  components: {
    Blocker: () => import('@/vcs/_shared/blocker/cmp.vue'),
  },
}
